import type { PromoCampaignPublic } from '@/lib/api'

export const PLAN_MONTHLY_OLIVES: Record<string, number> = {
  pro: 300,
  studio: 1500,
}

export const PLAN_PRICES: Record<string, number> = {
  pro: 30,
  studio: 150,
}

export const PLAN_NAMES: Record<string, string> = {
  pro: 'Pro',
  studio: 'Studio',
}

/**
 * Which plan rows the deal box shows — and, by length, whether it renders at all.
 *
 * A plan earns a row if the invite grants it bonus olives, or — while the
 * 50%-off-first-month promo is live — simply because it has a price: campaign
 * visitors are definitionally new users, so the discount is true for them even
 * on an invite that grants no olives (e.g. a pure skip-the-waitlist link).
 * Neither, or an inactive campaign ⇒ no box. Promo state comes from the REAL
 * backend flag on the campaign response, so the display can never outlive the
 * coupon: unset the reward env var and the box goes with it.
 */
export function getPromoDealPlans(
  campaign: Pick<PromoCampaignPublic, 'active' | 'rewards' | 'firstMonthPromoActive'>,
): string[] {
  if (!campaign.active) return []
  const promoActive = campaign.firstMonthPromoActive === true
  return Object.keys(PLAN_PRICES).filter(planId => promoActive || (campaign.rewards[planId]?.bonus_olives ?? 0) > 0)
}
